var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#515864",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.827 16.596l-.092.307s-.196.498-.525.592c-.352.243-.997.427-1.537.468-.638.049-1.304.104-1.887-.225-.545-.307-.886-.757-.9-1.401-.016-.68.172-1.32.363-1.963.235-.794.5-1.58.677-2.388.072-.326.125-.664.016-.998a.556.556 0 00-.539-.389c-.43-.004-.863-.031-1.277.135-.12.049-.143.021-.116-.095.036-.159.079-.316.114-.475.018-.082.068-.129.148-.156.64-.22 1.267-.508 1.943-.574.8-.078 1.609-.053 2.23.565.263.263.396.584.413.943.028.577-.084 1.136-.247 1.689a95.399 95.399 0 00-.79 2.787 2.29 2.29 0 00-.063.76c.033.414.304.643.779.663.438.019.847-.093 1.29-.244zM13.307 8.999c-.725.093-1.52-.518-1.655-1.118-.1-.442-.048-.844.24-1.222.326-.43.775-.641 1.307-.658.892-.028 1.738.476 1.797 1.442.041.667-.362 1.186-1.067 1.469-.206.082-.42.11-.622.086z",
    fill: "#fff"
  })));
}
export default SvgNotificationInfo;